import {Color} from '@benchling/nucleus-ui';
import React from 'react';
import {EdgeProps} from 'reactflow';

import BaseEdgeRenderer from 'ui-library/reactflow/edges/BaseEdgeRenderer';
import {EdgeType} from 'ui-library/reactflow/edges/edgeOptions';

export const PROCEDURE_RUN_DESIGN_FLOWCHART_EDGE_TYPE = 'procedureRunDesignFlowchartEdge';

/** Visual variant for a design flowchart edge. Add a variant plus color entry to introduce new tones. */
export type ProcedureRunDesignFlowchartEdgeVariant = 'default';

export interface ProcedureRunDesignFlowchartEdgeData {
  variant: ProcedureRunDesignFlowchartEdgeVariant;
}

/** Maps an edge variant to its stroke color. */
const EDGE_VARIANT_COLORS: Record<ProcedureRunDesignFlowchartEdgeVariant, string> = {
  default: Color.GRAY_600,
};

/** Renders a design flowchart edge as a bezier curve colored by its variant. */
export default function ProcedureRunDesignFlowchartEdge(
  props: EdgeProps<ProcedureRunDesignFlowchartEdgeData>
): JSX.Element {
  const variant = props.data?.variant ?? 'default';
  return <BaseEdgeRenderer {...props} data={{type: EdgeType.BEZIER, color: EDGE_VARIANT_COLORS[variant]}} />;
}

export const EDGE_TYPES = {
  [PROCEDURE_RUN_DESIGN_FLOWCHART_EDGE_TYPE]: ProcedureRunDesignFlowchartEdge,
};
